import { Css, Palette } from "~generated/css";
import { Maybe } from "~generated/graphqlTypes";
import { DateOnly } from "~utils";
import { getCutoffDaysRemaining } from "../../Configurator.utils";

/**
 *  Formats Cutoff days remaining label.
 *  Returns null when cutoff date is undefined or > 21 days.
 */
export function CutoffDaysRemaining(props: { cutoffDate: Maybe<DateOnly> }) {
  const { cutoffDate } = props;
  // Early return if no cutoff date
  if (!cutoffDate) return null;

  const cutoffDaysRemaining = getCutoffDaysRemaining(cutoffDate);
  if (cutoffDaysRemaining > 21) {
    return null;
  }
  const color = cutoffDaysRemaining < 4 ? Palette.Red300 : Palette.Orange200;
  const cutoffText =
    cutoffDaysRemaining < 0
      ? "Expired"
      : cutoffDaysRemaining === 0
        ? "Expires today"
        : `${cutoffDaysRemaining} days to cutoff`;
  return <div css={Css.t12.color(color).wsnw.$}>{cutoffText}</div>;
}
